module.exports = __webpack_public_path__ + "static/media/fairy_1.bedb9941.jpg";